module.exports = __webpack_public_path__ + "static/media/3_k1E_1,35_43,52.df6eef03.png";